import React from 'react';
import ReactDOM from 'react-dom/client';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "react-oidc-context";

const clientId = "c9m40fcvfkitn4sregk93d91i";
const postLogoutRedirectUri = "https://portal.sanduke.com";

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_rZb0TgxEC",
  client_id: clientId,
  redirect_uri: "https://portal.sanduke.com/scans",
  post_logout_redirect_uri: postLogoutRedirectUri,
  response_type: "code",
  scope: "phone openid email",
  metadata: {
    issuer: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_rZb0TgxEC",
    authorization_endpoint: "https://login.sanduke.com/oauth2/authorize",
    token_endpoint: "https://login.sanduke.com/oauth2/token",
    userinfo_endpoint: "https://login.sanduke.com/oauth2/userInfo",
    end_session_endpoint: `https://login.sanduke.com/logout?client_id=${clientId}&logout_uri=${postLogoutRedirectUri}`
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <App />
      </LocalizationProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
